import { LegalPage } from './PublicLayout';

export default function PrivacyPage() {
    return (
        <LegalPage title="Privacy Policy" updated="July 10, 2026" testid="privacy-page">
            <p>
                This Privacy Policy explains how Ease My Bill ("we", "us") collects, uses, and safeguards your personal and business information when you use easemybill.com and our web application ("Service"). We follow the principles of the Digital Personal Data Protection Act, 2023 (DPDP Act) and applicable Indian laws.
            </p>

            <h2>1. Information we collect</h2>
            <h3>You provide directly</h3>
            <ul>
                <li>Account: name, email, password (stored hashed), business name, PAN, GSTIN.</li>
                <li>Payment: card / UPI details are collected directly by Razorpay — we only receive transaction IDs and status.</li>
                <li>Uploads: bills, invoices, ledgers, receipts, and any notes you enter.</li>
                <li>Communication: emails or messages you send us at support@easemybill.com.</li>
            </ul>
            <h3>Collected automatically</h3>
            <ul>
                <li>Log data (IP, browser, device, pages visited, timestamps) for security and analytics.</li>
                <li>Cookies and local storage for session management and preferences.</li>
            </ul>

            <h2>2. Why we use it</h2>
            <ul>
                <li>Provide the core Service: OCR, alerts, exports, WhatsApp ingestion.</li>
                <li>Bill you correctly and manage your subscription.</li>
                <li>Protect against fraud, abuse, and unauthorized access (rate limits, account lockout, audit log).</li>
                <li>Communicate service updates, security notices, and (with consent) product news.</li>
                <li>Improve Ease My Bill through aggregated, de-identified analytics.</li>
            </ul>

            <h2>3. Third parties we share limited data with</h2>
            <ul>
                <li><strong>AI provider</strong> — bill images/PDFs are sent for OCR processing. The provider does not train on your data under our API terms.</li>
                <li><strong>Razorpay</strong> — payment processing.</li>
                <li><strong>MongoDB Atlas</strong> — encrypted database hosting (India region where available).</li>
                <li><strong>Twilio / Meta WhatsApp Business API</strong> — only if you use WhatsApp ingestion.</li>
                <li><strong>Sentry</strong> — error monitoring (may include IP address; excludes bill content).</li>
            </ul>
            <p>We do not sell your data. We do not share it with advertisers.</p>

            <h2>4. Data retention</h2>
            <ul>
                <li>Bills and account data are retained for as long as your account is active.</li>
                <li>Cancelled accounts: data is retained for 90 days to allow reactivation, then permanently deleted.</li>
                <li>Backups are rotated on a 30-day cycle.</li>
                <li>You can request immediate deletion any time (see Section 7).</li>
            </ul>

            <h2>5. Security</h2>
            <ul>
                <li>Passwords are hashed with bcrypt; we cannot see your password.</li>
                <li>All data in transit is encrypted with TLS 1.2+.</li>
                <li>Data at rest is encrypted (AES-256).</li>
                <li>Rate limiting, account lockout after 10 failed login attempts, and an immutable audit log protect against abuse.</li>
                <li>Optional 2FA (TOTP) is available in Settings for extra protection.</li>
            </ul>

            <h2>6. Your rights</h2>
            <p>Under Indian data-protection law you may:</p>
            <ul>
                <li>Access the personal data we hold about you.</li>
                <li>Correct inaccurate information.</li>
                <li>Request deletion (subject to legal/tax retention obligations).</li>
                <li>Request a portable export of your data.</li>
                <li>Withdraw consent for optional processing (e.g. marketing emails).</li>
            </ul>

            <h2>7. How to reach us</h2>
            <p>
                For any privacy request or grievance, email <a href="mailto:support@easemybill.com">support@easemybill.com</a>. We aim to respond within 7 business days.
            </p>

            <h2>8. Children</h2>
            <p>The Service is not directed at children under 18. We do not knowingly collect data from minors.</p>

            <h2>9. International transfers</h2>
            <p>
                Some sub-processors (e.g. our AI provider, Sentry) may process data outside India. We ensure they meet equivalent security standards and comply with applicable cross-border transfer rules.
            </p>

            <h2>10. Changes</h2>
            <p>
                We may update this Policy. Material changes will be notified 14 days in advance by email or in-app banner. The "Last updated" date above always reflects the latest revision.
            </p>
        </LegalPage>
    );
}
